import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { useSetPageBackground } from '@components/Layouts/usePageBackground';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { TireOfferStatusContent } from '@components/TireOffer/TireOfferStatusContent';
import { t } from '@lingui/core/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { useParams } from 'react-router-dom';

export const TireOfferStatus = () => {
  const { slug } = useParams() as { slug: string };
  // The offer flow's background, set before the early returns so the loading screen has it too.
  useSetPageBackground('grouped');

  const {
    data: tireOffer,
    isPending: isTireOfferPending,
    error: tireOfferError
  } = noddiAsync.useGet({
    type: URLKeys.getCarTireQuoteBySlug,
    input: { carTireQuoteSlug: slug },
    queryConfig: { staleTime: Infinity }
  });

  if (isTireOfferPending) {
    return <NoddiLoadingScreenWithTrans />;
  }

  if (tireOfferError) {
    return <ApiErrorPageWithTrans error={tireOfferError} />;
  }

  return (
    <ContentWrapperCustomerApp width='lg' hideBackButton title={t`Your tire order`}>
      <TireOfferStatusContent tireOffer={tireOffer} />
    </ContentWrapperCustomerApp>
  );
};
